import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-recupero-crediti-stragiudiziale-view',
  templateUrl: './form-ricorso-view.component.html',
  styleUrls: ['./form-ricorso-view.component.css']
})
export class FormRicorsoAmministrativoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
